import React, { memo, useCallback, useMemo } from 'react';
import SectionHeader from 'design-system/SectionHeader';
import { TextButtonLinkSeeAll } from 'design-system/TextButton';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import ActivityItem from './ActivityItem';
const LimitStopOrdersSection = ({ orders, assetId }) => {
    const navigation = useMainStackNavigation();
    const handleSeeAll = useCallback(() => {
        navigation.navigateDeprecated('InvestOrders', {
            assetId,
            tradingOrderType: 'limitAndStop',
        });
    }, [assetId]);
    const ordersLen = orders?.length;
    const seeAllBtn = useMemo(() => {
        if (ordersLen > 3) {
            return <TextButtonLinkSeeAll onPress={handleSeeAll}/>;
        }
        return null;
    }, [handleSeeAll, ordersLen]);
    if (!ordersLen) {
        return null;
    }
    const slicedOrders = orders.slice(0, 3);
    return (<>
      <SectionHeader largeVerticalMargins horizontalMargins button={seeAllBtn}>
        Limit and stop orders
      </SectionHeader>
      {slicedOrders.map((order, index) => (<ActivityItem key={order.id} item={order} withWrapper isFirstInSection={index === 0} isLastInSection={index + 1 === slicedOrders.length}/>))}
    </>);
};
export default memo(LimitStopOrdersSection);
